import { cn } from "@/lib/utils";
import posthog from "@/lib/posthog";

export default function NavLink({ href, children, className, onClick }) {
  const handleClick = (e) => {
    e.preventDefault();
    const slug = href.replace(/^#/, "").replace(/[^a-z0-9]+/gi, "_").toLowerCase();
    posthog.capture(`landing.nav.${slug}.clicked`);
    const id = href.replace(/^#/, "");
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (onClick) onClick();
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className={cn(
        "text-sm font-medium text-neutral-700 transition-colors hover:text-neutral-900",
        className
      )}
    >
      {children}
    </a>
  );
}
